import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ReactMarkdown from 'react-markdown';
import { translation } from '../tools';
import MetaTags from 'react-meta-tags';
import * as actions from "../shared/actions";
import store from "../shared/store";
import { Loader } from "../components/Loader";

function Content(props){
    const { privacyPage, lang, fontsLoadingCheck } = props;

    useEffect(() => {
        store.dispatch(actions.fetchPrivacyPage());
    }, []);

    return(
        <React.Fragment>
            <Header />
                <MetaTags>
                {privacyPage.meta_title ? 
                    <>
                        <title>{translation(privacyPage, "meta_title", lang)}</title>
                        <meta id="meta-title" name="title" content={translation(privacyPage, "meta_title", lang)} />
                        <meta id="og-title" property="og:title" content={translation(privacyPage, "meta_title", lang)} />
                        <meta id="twitter-title" property={translation(privacyPage, "meta_title", lang)} /> 
                    </>
                    :
                    <>
                        <title>{translation(privacyPage, "title", lang)}</title>
                        <meta id="meta-title" name="title" content={translation(privacyPage, "title", lang)} />
                        <meta id="og-title" property="og:title" content={translation(privacyPage, "title", lang)} />
                        <meta id="twitter-title" property={translation(privacyPage, "title", lang)} /> 
                    </>
                }
                {privacyPage.meta_description ?
                    <>
                        <meta id="meta-description" name="description" content={translation(privacyPage, "meta_description", lang)} />
                        <meta id="og-description" property="og:description" content={translation(privacyPage, "meta_description", lang)} /> 
                        <meta id="twitter-description" property={translation(privacyPage, "meta_description", lang)} /> 
                    </>
                    :
                    <>
                        <meta id="meta-description" name="description" content={translation(privacyPage, "title", lang)} />
                        <meta id="og-description" property="og:description" content={translation(privacyPage, "title", lang)} /> 
                        <meta id="twitter-description" property={translation(privacyPage, "title", lang)} /> 
                    </>
                }
                <link rel="canonical" />
                <meta id="og-url" property="og:url" content={window.location.href} />
                <meta id="twitter-url" property="twitter:url" content={window.location.href} />
                </MetaTags>
                <Loader loaded={fontsLoadingCheck}/>
            <section className={`cms ${props.className && props.className}`}>
                <div className="container">
                    <div className="row">
                        <div className="col col-ms-12">
                            {privacyPage.title && <h1>{translation(privacyPage, "title", lang)}</h1>}
                            {privacyPage.content &&
                                <ReactMarkdown
                                    className={`text`}
                                    source={translation(privacyPage, "content", lang)}
                                    escapeHtml={false}
                                />
                            }
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    );
}

const mapStateToProps = (state) => ({
    privacyPage: state.privacyPage,
    lang: state.lang,
    fontsLoadingCheck: state.fontsLoadingCheck,
});

export default connect(mapStateToProps, null)(Content);